import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/shared/Logo";
import { useLang } from "@/context/LanguageContext";
import { Send } from "lucide-react";

export function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-brand-navy2" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Logo size="h-9" />
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">{t("footer_tagline")}</p>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">{t("footer_platform")}</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/vip" className="hover:text-brand-cyan">{t("nav_vip")}</Link></li>
              <li><Link to="/brokers" className="hover:text-brand-cyan">{t("nav_brokers")}</Link></li>
              <li><Link to="/education" className="hover:text-brand-cyan">{t("nav_education")}</Link></li>
              <li><Link to="/results" className="hover:text-brand-cyan">{t("nav_results")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">{t("footer_company")}</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/about" className="hover:text-brand-cyan">{t("nav_about")}</Link></li>
              <li><Link to="/offers" className="hover:text-brand-cyan">{t("nav_offers")}</Link></li>
              <li><Link to="/faq" className="hover:text-brand-cyan">{t("nav_faq")}</Link></li>
              <li><Link to="/contact" className="hover:text-brand-cyan">{t("nav_contact")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display text-sm font-semibold text-white mb-4">{t("footer_legal")}</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/legal/privacy" className="hover:text-brand-cyan">{t("privacy")}</Link></li>
              <li><Link to="/legal/terms" className="hover:text-brand-cyan">{t("terms")}</Link></li>
              <li><Link to="/legal/risk" className="hover:text-brand-cyan">{t("risk_disclosure")}</Link></li>
              <li><Link to="/legal/disclaimer" className="hover:text-brand-cyan">{t("disclaimer")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10">
          <p className="text-xs text-slate-500">© {year} INVIXA TRADERS. {t("rights")}</p>
        </div>
      </div>
    </footer>
  );
}
